export enum TabPanelOptions {
  RECEIVED_LISTS = 'receivedLists',
  CREATED_LISTS = 'createdLists',
}
